import { StoreState } from '../types';

export const selectAboutUs = (state: StoreState) => state.app.aboutUs;
export const selectLocationIds = (state: StoreState) => state.app.locationIds;
export const selectWidgetScreen = (state: StoreState) => state.app.screen;
export const selectWidgetHeader = (state: StoreState) => state.app.header;
export const selectScreenData = (state: StoreState) => state.app.screenData;
